<template>
  <div class="card">
    <div style="margin-bottom:10px;">Product No.: {{ $route.params.id }}</div>
    <div class="table-title">Incoming</div>
    <table class="cystron-table">
      <tr class="green-bg">
        <th>Issue Date</th>
        <th style="width:44px;text-align:right;">Qty</th>
        <th style="width:52px;">(HK stk</th>
        <th style="width:52px;">SZ stk</th>
        <th style="width:50px;">BB)</th>
        <th>Price</th>
        <th>PO No.</th>
        <th>Company</th>
        <th>Sales</th>
      </tr>
      <tr v-for="(item, index) in incomingList" :key="index">
        <td>{{item.doc_date}}</td>
        <td style="text-align:right;">{{item.qty}}</td>
        <td>({{item.qty_hk}}</td>
        <td>{{item.qty_sz}}</td>
        <td>{{item.qty_bb}})</td>
        <td><span style="color:#6f76b1">{{item.currency}}</span>{{item.price}}</td>
        <td><a @click="$open(`/po-order-view/${item.doc_id}`, 840)">{{item.doc_id_display}}</a></td>
        <td>{{item.company_fullname}}</td>
        <td>{{item.sales_fullname}}</td>
      </tr>
    </table>
    <no-data :padding="20" :loading="false" :list="incomingList"></no-data>
    <div class="table-title" style="margin-top:15px;">Reservation</div>
    <table class="normal-table">
      <tr>
        <th>Issue Date</th>
        <th style="width:44px;text-align:right;">Qty</th>
        <th style="width:52px;">(HK stk</th>
        <th style="width:52px;">SZ stk</th>
        <th style="width:50px;">BB)</th>
        <th>Price</th>
        <th>INV No.</th>
        <th>Company</th>
        <th>Sales</th>
      </tr>
      <tr v-for="(item, index) in invList" :key="index">
        <td>{{item.doc_date}}</td>
        <td style="text-align:right;">{{item.qty}}</td>
        <td>{{item.qty_hk}}</td>
        <td>{{item.qty_sz}}</td>
        <td>{{item.qty_bb}}</td>
        <td><span style="color:#6f76b1">{{item.currency}}</span>{{item.price}}</td>
        <td><a @click="$open(`/invoice-order-view/${item.doc_id}`, 840)">{{item.doc_id_display}}</a></td>
        <td>{{item.company_fullname}}</td>
        <td>{{item.sales_fullname}}</td>
      </tr>
    </table>
    <no-data :padding="20" :loading="false" :list="invList"></no-data>
    <table class="fixed-table" style="margin-top:15px;">
      <tr style="height:0;border:0">
        <th style="width:70px;"></th>
        <th style="width:80px;"></th>
        <th></th>
        <th style="width:70px;"></th>
        <th style="width:50px;"></th>
        <th style="width:50px;"></th>
        <th style="width:50px;"></th>
        <th style="width:50px;"></th>
        <th style="width:50px;"></th>
        <th style="width:50px;"></th>
        <th style="width:70px;"></th>
        <th style="width:30px;"></th>
        <th style="width:80px;"></th>
        <th></th>
        <th style="width:60px;"></th>
        <th style="width:40px;"></th>
        <th style="width:60px;"></th>
      </tr>
      <tr>
        <th colspan="3" style="background:#194685;color:#fff;">Stock IN</th>
        <th style="background:#194685;color:#fff;text-align:right;">Total:&nbsp;</th>
        <th style="background:#194685;color:#fff;text-align:right;">{{stockInTotalQtyBB}}</th>
        <th style="background:#194685;color:#fff;text-align:right;">{{stockInTotalQtyHK}}</th>
        <th style="background:#194685;color:#fff;text-align:right;">{{stockInTotalQtySZ}}</th>
        <th style="background:#194685;color:#fff;text-align:right;">{{stockInTotalBB}}</th>
        <th style="background:#194685;color:#fff;text-align:right;">{{stockInTotalHK}}</th>
        <th style="background:#194685;color:#fff;text-align:right;">{{stockInTotalSZ}}</th>
        <th colspan="7" style="background:#A30C7D;color:#fff;">Stock OUT</th>
      </tr>
      <tr>
        <th>Date</th>
        <th>PO No.</th>
        <th>Company</th>
        <th>Cost</th>
        <th>BB</th>
        <th>HK</th>
        <th>SZ</th>
        <th>BB Bal</th>
        <th>HK Bal</th>
        <th>SZ Bal</th>
        <th>Date</th>
        <th>Type</th>
        <th>INV No.</th>
        <th>Company</th>
        <th>Price</th>
        <th>Qty</th>
        <th>Sales</th>
      </tr>
      <tr v-for="(item, index) in stockList" :key="index">
        <td>{{ item.enter_date }}</td>
        <td v-if="item.doc_id"><a @click="$open(`/po-order-view/${item.doc_id}`, 840)">PO CYS{{item.doc_id}}</a></td>
        <td v-else>&nbsp;</td>
        <td :title="item.company_name">{{ item.company_name }}</td>
        <td><span style="color:#6f76b1" v-if="item.currency">{{ item.currency }}</span>{{ item.price }}</td>
        <td style="text-align:right;">{{item.qty_bb}}</td>
        <td style="text-align:right;">{{item.qty_hk}}</td>
        <td style="text-align:right;">{{item.qty_sz}}</td>
        <td style="text-align:right;color:red;">{{item.bb}}</td>
        <td style="text-align:right;color:red;">{{item.hk}}</td>
        <td style="text-align:right;color:red;">{{item.sz}}</td>
        <td>{{ item.out_date }}</td>
        <td>{{ item.out_type }}</td>
        <td v-if="item.pi_doc_id"><a @click="$open(`/invoice-order-view/${item.pi_doc_id}`, 840)">INV CYS{{ item.pi_doc_id }}</a></td>
        <td v-else>&nbsp;</td>
        <td :title="item.pi_company_name">{{ item.pi_company_name }}</td>
        <td><span style="color:#6f76b1" v-if="item.out_currency">{{ item.out_currency }}</span>{{ item.out_price }}</td>
        <td style="text-align:right;">{{ item.out_qty }}</td>
        <td>{{ item.pi_sales_name }}</td>
      </tr>
    </table>
    <no-data :padding="20" :loading="false" :list="stockList"></no-data>
  </div>
</template>

<script>
import qs from 'qs'
import NoData from '@/components/NoData'
export default {
  components: {
    NoData
  },
  props: {
    productId: String
  },
  data () {
    return {
      poList: [],
      invList: [],
      stockList: []
    }
  },
  computed: {
    incomingList () {
      return this.poList.filter(r => !r.delivery_date_e)
    },
    stockInTotalQtyBB () {
      let t = 0
      for (let i = 0; i < this.stockList.length; i++) {
        if (!!this.stockList[i].qty_bb) {
          t += this.stockList[i].qty_bb
        }
      }
      return t
    },
    stockInTotalQtyHK () {
      let t = 0
      for (let i = 0; i < this.stockList.length; i++) {
        if (!!this.stockList[i].qty_hk) {
          t += this.stockList[i].qty_hk
        }
      }
      return t
    },
    stockInTotalQtySZ () {
      let t = 0
      for (let i = 0; i < this.stockList.length; i++) {
        if (!!this.stockList[i].qty_sz) {
          t += this.stockList[i].qty_sz
        }
      }
      return t
    },
    stockInTotalBB () {
      let t = 0
      for (let i = 0; i < this.stockList.length; i++) {
        if (!!this.stockList[i].bb) {
          t += this.stockList[i].bb
        }
      }
      return t
    },
    stockInTotalHK () {
      let t = 0
      for (let i = 0; i < this.stockList.length; i++) {
        if (!!this.stockList[i].hk) {
          t += this.stockList[i].hk
        }
      }
      return t
    },
    stockInTotalSZ () {
      let t = 0
      for (let i = 0; i < this.stockList.length; i++) {
        if (!!this.stockList[i].sz) {
          t += this.stockList[i].sz
        }
      }
      return t
    }
  },
  mounted () {
    this.fetchPoList()
    this.fetchInvList()
    this.fetchStockList()
  },
  methods: {
    fetchPoList () {
      this.$http('/dbapi/po_list?product_id=' + this.$route.params.id).then(data => {
        this.poList = data.list
        return this.$http.get('/dbapi/po_sold_list', {
          params: {
            ids: this.poList.map(r => r.id)
          },
          paramsSerializer: function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        })
      }).then(data => {
        if (data.list.length > 0) {
          let list = this.poList.slice()
          let solds = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].solds = []
            for (let k = 0; k < solds.length; k++) {
              if (solds[k].po_id === list[i].id) {
                list[i].solds.push(solds[k])
              }
            }
          }
          this.poList = list
        }
      })
    },
    fetchInvList () {
      this.$http('/dbapi/invoice_list?is_delivery=0&product_id=' + this.$route.params.id).then(data => {
        this.invList = data.list
      })
    },
    fetchStockList () {
      this.$http.get('/dbapi/po_stock_balance_detail?product_id=' + this.$route.params.id).then(data => {
        let list = data.list
        for (let i = 0; i < list.length; i++) {
          list[i].qty_bb = parseInt(list[i].qty_bb)
          list[i].qty_hk = parseInt(list[i].qty_hk)
          list[i].qty_sz = parseInt(list[i].qty_sz)
          list[i].bb = parseInt(list[i].bb)
          list[i].hk = parseInt(list[i].hk)
          list[i].sz = parseInt(list[i].sz)
        }
        this.stockList = list
        this.fetchStockOutList()
      })
    },
    fetchStockOutList () {
      this.$http.get('/dbapi/stock_out_list?product_id=' + this.$route.params.id).then(data => {
        let list = this.stockList.slice()
        let list2 = data.list
        for (let i = 0; i < list2.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (list2[i].po_doc_id === list[j].doc_id) {
              if (!list[j].out_type) {
                list[j].out_date = list2[i].stock_date
                list[j].out_type = list2[i].stock_type
                list[j].pi_doc_id = list2[i].pi_doc_id
                list[j].pi_company_name = list2[i].pi_company_name
                list[j].out_price = list2[i].price
                list[j].out_currency = list2[i].pi_currency
                list[j].out_qty = list2[i].bb + list2[i].hk + list2[i].sz
                list[j].pi_sales_name = list2[i].pi_sales_name
              } else {
                list.splice(j + 1, 0, {
                  out_date: list2[i].stock_date,
                  out_type: list2[i].stock_type,
                  pi_doc_id: list2[i].pi_doc_id,
                  pi_company_name: list2[i].pi_company_name,
                  out_price: list2[i].price,
                  out_currency: list2[i].pi_currency,
                  out_qty: list2[i].bb + list2[i].hk + list2[i].sz,
                  pi_sales_name: list2[i].pi_sales_name
                })
              }
              break
            }
          }
        }
        this.stockList = list
      })
    }
  }
}
</script>

